// extracted by mini-css-extract-plugin
export var list = "index-module--list---otvb";
export var listItem = "index-module--list-item--IaUiu";